class ApiError {
	constructor(code) {
		this.code = code;
	}
}

export default ApiError;
